import { Component, EventEmitter, Output, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { WebViewInteropService } from 'src/app/service/web-view-interop.service';
import { ConfigService, IClientConfig } from 'src/app/service/config.service';
import { environment } from 'src/environments/environment';
import { DialogComponent } from '../dialog.component';

@Component({
    selector: 'app-about-dialog',
    templateUrl: './about-dialog.component.html',
    imports: [DialogComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AboutDialogComponent {
  @Output() closed = new EventEmitter<void>();

  environmentVersion = environment.version;
  config: IClientConfig | undefined;

  constructor(
    private webViewInterop: WebViewInteropService,
    private configService: ConfigService
  ) {
    this.config = this.configService.getClientConfiguration();
  }

  openLink(url: string) {
    this.webViewInterop.openLink(url.startsWith("http") ? url : "http://" + url);
  }

  close() {
    this.closed.emit();
  }
}